import React from 'react';
import { Provider } from 'react-redux';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './redux/store';

const { store, persistor } = configureStore();

const AppProvider = () => (
  // @ts-ignore
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App dispatch={store.dispatch} />
    </PersistGate>
  </Provider>
);

export default AppProvider;
